// https://stackoverflow.com/questions/10756313/javascript-jquery-map-a-range-of-numbers-to-another-range-of-numbers

const scale = (number, inMin, inMax, outMin, outMax) => {
  return (
    ((number - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin
  )
}

export { scale }
